import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

import { ANIMATIONS } from './animations.data';

/**
 * Animates show/hide router
 *
 * @example
 * [@fadeInAnimation]="true"
 *
 */
export const fadeInAnimation: AnimationTriggerMetadata = trigger(
    'fadeInAnimation', [
        transition(':enter', [

            // styles at start of transition
            style({ opacity: 0 }),

            // animation and styles at end of transition
            animate(ANIMATIONS.speed.default, style({ opacity: 1 }))
        ])
]);
